function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-1215-4316H225v6638h-1440z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 29,
  x: 0.5,
  y: 0.5,
  stroke: "#DEDEDE",
  rx: 14.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4A2A8",
  fillRule: "nonzero",
  d: "M9.75 15.75h10.5a.75.75 0 100-1.5H9.75a.75.75 0 000 1.5z"
})));

var SvgFaqClose = function SvgFaqClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjE1IC00MzE2KSI+CiAgICA8cmVjdCB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI2NjM4IiBmaWxsPSIjRkZGRkZGIi8+CiAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjE1IDQzMTYpIj4KICAgICAgPHJlY3Qgd2lkdGg9IjI5IiBoZWlnaHQ9IjI5IiB4PSIuNSIgeT0iLjUiIHN0cm9rZT0iI0RFREVERSIgcng9IjE0LjUiLz4KICAgICAgPHBhdGggZmlsbD0iI0E0QTJBOCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNMC43NSwxLjc1IEwxMS4yNSwxLjc1IEMxMS42NjQyMTM2LDEuNzUgMTIsMS40MTQyMTM1NiAxMiwxIEMxMiwwLjU4NTc4NjQzOCAxMS42NjQyMTM2LDAuMjUgMTEuMjUsMC4yNSBMMC43NSwwLjI1IEMwLjMzNTc4NjQzOCwwLjI1IDAsMC41ODU3ODY0MzggMCwxIEMwLDEuNDE0MjEzNTYgMC4zMzU3ODY0MzgsMS43NSAwLjc1LDEuNzUgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOSAxNCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgFaqClose as ReactComponent };